export class UserSettings {

  /** 组织是否启用（默认 false） */
  organizationEnabled: boolean = false;
}